import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@kit/ui/utils';

import styles from './website-glass-surface.module.css';

export interface WebsiteGlassSurfaceProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'article' | 'section' | 'figure' | 'p';
  tone?: 'auto' | 'light' | 'dark';
  material?: 'panel' | 'pill';
  children: ReactNode;
}

/** One backdrop layer; foreground text and controls always remain sharp. */
export function WebsiteGlassSurface({
  as: Tag = 'div',
  tone = 'auto',
  material = 'panel',
  children,
  className,
  ...props
}: WebsiteGlassSurfaceProps) {
  return (
    <Tag
      {...props}
      data-website-glass
      data-tone={tone}
      data-material={material}
      className={cn(styles.surface, className)}
    >
      {children}
    </Tag>
  );
}
